import React from 'react';
import Link from 'components/AppSafeLink/AppSafeLink';
import PropTypes from 'prop-types';
import '/public/css/components/mnLegacy.css';

const LegacySlug = 'mn-legacy-amendment';

const MnLegacy = (props) => {
  const shouldDisplay = Boolean(
    props.collections.find((item) => item.canonicalSlug === LegacySlug)
  );

  return shouldDisplay ? (
    <div className="template-nsj">
      <section className="container legacy-nsj">
        <Link
          href="https://www.mpr.org/public/legacy-amendment-projects"
          className="legacy-logo"
        >
          <img
            src="/legacy_logo.png"
            width={751}
            height={425}
            alt="Minnesota Legacy Fund Logo"
          />
        </Link>
        <div className="legacy-blurb">
          This activity is made possible in part by the{' '}
          <strong>
            <Link href="https://www.mpr.org/public/legacy-amendment-projects">
              Minnesota Legacy Amendment&apos;s Arts & Cultural Heritage Fund
            </Link>
          </strong>
          .
        </div>
      </section>
    </div>
  ) : null;
};

MnLegacy.propTypes = {
  collections: PropTypes.array,
};

export default MnLegacy;
